module.exports = __webpack_public_path__ + "img/481.f48b0c4d.jpg";